import { styled } from "@linaria/react"

import { monospaceFont } from "@/styles/textStyles.ts"

const SwatchContainer = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;

  padding: 0 4px;
  background: var(--text-color-5);
  border-radius: var(--border-radius-6);
  vertical-align: middle;
`

const SwatchBox = styled.span<{ color: string }>`
  display: inline-block;
  width: 16px;
  height: 16px;

  border-radius: var(--border-radius-4);
  background: ${props => props.color};
`

const ColorCode = styled.span`
  ${monospaceFont};
`

export const ColorSwatch = ({ color }: { color: string }) => {
  return (
    <SwatchContainer>
      <SwatchBox color={color} />
      <ColorCode>{color}</ColorCode>
    </SwatchContainer>
  )
}
